import * as React from "react";
import styled, { css } from "styled-components";
import { Accordion } from "@mantine/core";
export const nonInteractiveListItemClass = "non-interactive-expandable-list-item";
const NonInteractiveItem = styled.div(
  ({ theme }) => css`
    padding-top: ${theme.spacings.xs};
    padding-bottom: ${theme.spacings.xs};
    min-height: 34px;
    display: flex;
    align-items: center;
  `
);
const ContentContainer = styled.div(
  ({ theme }) => css`
    border-left: 1px ${theme.colors.gray[90]} solid;
    padding-left: 18px;
  `
);
const Subheader = styled.span(
  ({ theme }) => css`
    font-size: ${theme.fonts.size.body};
    margin-left: 0.5em;
    color: ${theme.colors.gray[70]};
  `
);
const StyledAccordionItem = styled(Accordion.Item)(
  ({ theme }) => css`
    .mantine-Accordion-chevron {
      margin-left: ${theme.spacings.xxs};
      margin-right: ${theme.spacings.sm};
    }

    .mantine-Accordion-content {
      padding-left: 11px;
      padding-right: 0;
    }

    .mantine-Accordion-label {
      padding-top: ${theme.spacings.xs};
      padding-bottom: ${theme.spacings.xs};
    }
  `
);
const StyledAccordionControl = styled(Accordion.Control)`
  padding-right: 0;
`;
const ExpandableListItem = ({
  header,
  children = void 0,
  value,
  subheader = void 0,
  expandable = true
}) => {
  if (!expandable) {
    return /* @__PURE__ */ React.createElement(NonInteractiveItem, { className: nonInteractiveListItemClass }, header, subheader && /* @__PURE__ */ React.createElement(Subheader, null, subheader));
  }
  return /* @__PURE__ */ React.createElement(StyledAccordionItem, { value }, /* @__PURE__ */ React.createElement(StyledAccordionControl, null, header, subheader && /* @__PURE__ */ React.createElement(Subheader, null, subheader)), /* @__PURE__ */ React.createElement(Accordion.Panel, null, /* @__PURE__ */ React.createElement(ContentContainer, null, children)));
};
export default ExpandableListItem;
